// import { responsiveFontSizes } from '@mui/material/styles';

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1500px)': {
      fontSize: pxToRem(lg),
    },
  };
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    fontWeightSemiBold: React.CSSProperties['fontWeight'];
  }
}

const primaryFont = 'Public Sans, sans-serif'; // Google Font
// const secondaryFont = 'CircularStd, sans-serif'; // Local Font

// ----------------------------------------------------------------------

export const typography = {
  // fontSize: pxToRem(16),
  ...responsiveFontSizes({ sm: 9, md: 9, lg: 11 }),
  fontFamily: primaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 80 / 64,
    fontSize: pxToRem(36),
    ...responsiveFontSizes({ sm: 47, md: 52, lg: 58 }),
  },
  h2: {
    fontWeight: 800,
    lineHeight: 64 / 48,
    fontSize: pxToRem(29),
    ...responsiveFontSizes({ sm: 36, md: 40, lg: 43 }),
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(22),
    ...responsiveFontSizes({ sm: 23, md: 27, lg: 29 }),
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 22, lg: 22 }),
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 17, md: 18, lg: 18 }),
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(15),
    ...responsiveFontSizes({ sm: 16, md: 16, lg: 16 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 13, md: 13, lg: 14 }),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(13),
    ...responsiveFontSizes({ sm: 11, md: 11, lg: 13 }),
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(13),
    // ...responsiveFontSizes({ sm: 13, md: 13, lg: 13 }),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(13),
    ...responsiveFontSizes({ sm: 11, md: 11, lg: 13 }),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(11),
    ...responsiveFontSizes({ sm: 9, md: 9, lg: 11 }),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    textTransform: 'uppercase',
    fontSize: pxToRem(11),
    ...responsiveFontSizes({ sm: 9, md: 9, lg: 11 }),
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    textTransform: 'unset',
    fontSize: pxToRem(13),
    ...responsiveFontSizes({ sm: 11, md: 11, lg: 13 }),
  },
} as const;
